<template>
  <purchase-details v-if="lot" :lot="lotCopy"></purchase-details>
</template>

<script>
  import Vue from 'vue'
  import PurchaseDetails from './Details'
  import CommonMixins from './mixins/common'
  import PermissionsMixins from './mixins/permissions'

  export default {
    components: {
      PurchaseDetails
    },

    data: () => ({
      lotCopy: undefined,
      lotCopyWatcher: undefined
    }),

    mixins: [
      CommonMixins,
      PermissionsMixins
    ],

    computed: {
      lotId() {
        return +this.$route.params.lotId;
      },

      lot() {
        return this.$store.getters.lot(this.lotId);
      }
    },

    watch: {
      lot: {
        deep: true,
        immediate: true,
        handler: function(value, old) {
          console.info('Main: detected lot object is changed lot=', value, ', old=', old);

          if (this.lotCopyWatcher) this.lotCopyWatcher();
          this.lotCopy = Vue.observable(_.cloneDeep(value));

          this.lotCopyWatcher = this.$watch('lotCopy', function(value, old) {
            console.info('Main: detected the сopy of lot object is changed lot=', value, ', old=', old);
            this.checkForm(_.cloneDeep(value));
          }, {
            deep: true
          });
        }
      }
    },

    async created() {
      this.runBlockerAction(async () => {
        try {
          await this.$store.dispatch('fetchLot', { lotId: this.lotId });
        }
        catch(e) {
          console.error('unable to fetch public lot', e);
          this.globalErrorHandler(e);
        }
      });
    }
  }
</script>

<style scoped>

</style>
